import React from "react";
import "../components/Footer.css";
import logo from "../assets/img/logo.png";
import facebook from "../assets/img/Footer_img/facebookicon.png";
import linkedin from "../assets/img/Footer_img/linkedinicon.png";
import instagram from "../assets/img/Footer_img/instagramicon.png";
import whatsapp from "../assets/img/Footer_img/whatsappicon.png";
import youtube from "../assets/img/Footer_img/youtubeicon.png";
import phone from "../assets/img/Footer_img/phone.png";
import email from "../assets/img/Footer_img/email.png";
import { Link } from 'react-router-dom'


const Footer = () => {
  const usefulLinks = [
    { name: "Home Page", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/Products" },
    { name: "Projects", path: "/projects" },
    { name: "Roadmap", path: "/Roadmap" },
    { name: "Contact Us", path: "/getquotations" },
  ];

  const products2=[
    {name:"Indoor Playground Manufacturer",path:"/IndoorPlayground"},
     { name: "Soft Play Manufacturer", path: "/IndoorPlayground/SoftPlay" },
  { name: "Trampoline Park Manufacturer", path: "/TrampolinePark" },
  { name: "Indoor Playground Supplier", path: "/IndoorPlayground" },
  { name: "Soft Play Supplier", path: "IndoorPlayground/SoftPlay" },
  { name: "Trampoline Manufacturer", path: "/TrampolinePark" },
  { name: "Trampoline Supplier", path: "/TrampolinePark" },
  { name: "Climbing Wall Manufacturer", path: "/Climbingwall" },
  { name: "Climbing Wall Supplier", path: "/Climbingwall" },
  { name: "Challenge Game Manufacturer", path: "/Interactivegames" },
  { name: "Challenge Game Supplier", path: "/Interactivegames" },
  { name: "Trampoline Park Supplier", path: "/TrampolinePark" },
  { name: "Assault Course Supplier", path: "/NinjaPark/NinjaCourse" },
  { name: "Assault Course Manufacturer", path: "/NinjaPark/NinjaCourse" },
  { name: "Ninja Course Manufacturer", path: "/NinjaPark" },
  { name: "Ninja Course Supplier", path: "/NinjaPark" },
  { name: "Soft Play Installation", path: "/IndoorPlayground/SoftPlay" },
  { name: "Family Entertainment Centers Manufacturer", path: "/NinjaPark/NinjaKids" },
  { name: "Indoor Playground Production", path: "/IndoorPlayground" },
  { name: "Soft Play Production", path: "/IndoorPlayground/SoftPlay" },
  { name: "Trampoline Park Production", path: "/TrampolinePark" },
  { name: "Indoor Playground Equipment", path: "/IndoorPlayground" },
];

  

  const products = [
    { name: "Trampoline Park", path: "/TrampolinePark" },
    { name: "Indoor Playground", path: "/IndoorPlayground" },
    { name: "Interactive Games", path: "/Interactivegames" },
    { name: "Climbing Wall", path: "/Climbingwall" },
    { name: "Ninja Park", path: "/NinjaPark" },
    { name: "Entrance Software", path: "/EntranceSoftware" }
  ]

  const socialIcons = [
    { imgSrc: facebook, alt: "Facebook", link: "https://www.facebook.com/gemjo01" },
    { imgSrc: linkedin, alt: "LinkedIn", link: "https://www.linkedin.com/company/global-entertainment-manufacturer/" },
    { imgSrc: instagram, alt: "Instagram", link: "https://www.instagram.com/gemanufacturer/" },
    { imgSrc: whatsapp, alt: "WhatsApp", link: "https://wa.me/+962791008716" },
    { imgSrc: youtube, alt: "YouTube", link: "https://www.youtube.com/channel/UCaJVNG5UtvdQPcRuBd99L5g" },
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <img
          src={logo}
          alt="indoor playground"
          className="logo"
        />
        <div className="columns-container">
          <div className="description-column">
            <h1 className="description">
               {products2.map((product, index) => (
      <React.Fragment key={product.name}>
        <a className="no-decoration" href={product.path}>{product.name}</a>
        {index < products2.length - 1 && ", "}
      </React.Fragment>
    ))}
              {/* Indoor Playground Manufacturer, Soft Play Manufacturer, Trampoline
              Park Manufacturer, Indoor Playground Supplier, Soft Play Supplier,
              Trampoline Manufacturer, Trampoline Supplier, Climbing Wall
              Manufacturer, Climbing Wall Supplier, Challenge Game Manufacturer,
              Challenge Game Supplier, Trampoline Park Supplier, Assault Course
              Supplier, Assault Course Manufacturer, Ninja Course Manufacturer,
              Ninja Course Supplier, Soft Play Installation, Family
              Entertainment Centers Manufacturer, Indoor Playground Production,
              Soft Play Production, Trampoline Park Production, Indoor
              Playground Equipment, Indoor Playground Supplier, Family
              Entertainment Centers Manufacturer */}
            </h1>
          </div>

        
          <div style={{ display: "flex", flexDirection: "columns" }}>

            <div style={{ display: "flex" }}>
              <div className="f-column">
                <h3>Useful Links</h3>
                <ul>
                  {usefulLinks.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="no-decoration">
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Third Column */}
            <div className="f-column">
              <h3>Products</h3>
              <ul>

                {products.map((product, index) => (
                  <Link to={product.path} className="no-decoration">
                    <li key={index}>{product.name}</li>
                  </Link>
                ))}
              </ul>
            </div>

          </div>
          <div className="contact-info">
            <h3>Contact Information</h3>

            <p style={{ marginTop: "1%", marginBottom: "-5%" }}>
              Sahab, Street No. 60, <br /> Amman, Jordan.
            </p>
            <div style={{ marginTop: "6%" }} className="contact-item">
              <div className='phone-link'>
                <p onClick={() => window.open(`https://wa.me/962791008716`, "_blank")}>+962791008716</p></div>
              <img src={phone} alt="Phone" className="icon" />
            </div>
            <div style={{ marginBottom: "20px" }} className="contact-item-email">
              <a  href="mailto:info@gemplay.com.jo">info@gemplay.com.jo</a>
              <img src={email} alt="Email" className="icon" />
            </div>

            <div className="social-icons">
              {socialIcons.map((icon, index) => (
                <a
                  key={index}
                  href={icon.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={icon.imgSrc} alt={icon.alt} />
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
